import {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import image404 from '../../../assets/image/sponsor/404.svg';
import useGetSponserList from '../../../services/hookService/sponsor/useGetSponserList/useGetSponserList';
import DotsLoading from '../../../components/dotsLoading';
import SponsorHeader from '../components/header';
import OldPlanBox from '../components/OldPlanBox';
import SponsorCustomButton from '../components/CustomButton';
const OldPlanPage = () => {
  const navigate = useNavigate();
  const {data, isLoading} = useGetSponserList();
  const [oldPlan, setOldPlan] = useState<sponserItem[]>([]);
  useEffect(() => {
    if (!data) return;
    const oldPlans = data.filter(
      plane =>
        plane.status === 'accepted' && plane.number_messages.previous_plans,
    );
    setOldPlan(oldPlans);
  }, [data]);
  return (
    <div className="flex flex-col h-[100dvh] bg-white w-full text-gray-800 text-sm">
      <SponsorHeader title="حامی مالی" />
      <div className="max-h-[calc(100dvh-57px)] flex flex-col gap-2 justify-between px-8 pt-6 pb-8 ">
        <span className="shrink-0 mb-2">طرح‌های قبلی </span>
        <div className="flex flex-col gap-2 overflow-y-scroll no-scrollbar">
          {isLoading ? (
            <div className=" w-full flex flex-col items-center justify-center mt-16">
              <DotsLoading />
            </div>
          ) : (
            <>
              {oldPlan.length ? (
                <>
                  {oldPlan.map(plan => (
                    <OldPlanBox key={plan.text} {...plan} />
                  ))}
                </>
              ) : (
                <div className=" w-full flex flex-col items-center gap-6 mb-12 mt-[68px]">
                  <img
                    src={image404}
                    className="w-[50px] h-[50px]"
                    alt="not found active plane"
                  />
                  <span>موردی برای نمایش وجود ندارد</span>
                </div>
              )}
              {/* start link go back */}
              <SponsorCustomButton
                outline={oldPlan.length ? false : true}
                buttonType="button"
                disabled={false}
                title="بازگشت"
                handler={() => navigate(-1)}
              />
              {/* end link go back */}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default OldPlanPage;
